import { render, staticRenderFns } from "./virtual-payment-list.vue?vue&type=template&id=6d596bf0&scoped=true"
import script from "./virtual-payment-list.vue?vue&type=script&lang=js"
export * from "./virtual-payment-list.vue?vue&type=script&lang=js"
import style0 from "./virtual-payment-list.vue?vue&type=style&index=0&id=6d596bf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d596bf0",
  null
  
)

export default component.exports